import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
})

export const StyledTitleWrapped = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingXSmall,
  fontSize: '1.5rem',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
}))

export const ZohoLogo = styled('img', {
  width: '1.25rem',
  height: '1.25rem',
})

export const ChangeUserContainer = styled('div', {
  width: '100%',
  display: 'flex',
  gridColumn: '1 / -1',
})
